import type { PriceJourney } from '@massilia/queries'

export const TRIP_TYPE_LABELS: Record<string, string> = {
  'multi-destination': 'Multi-destinations',
  'one-way': 'Aller simple',
  'round-trip': 'Aller-retour',
}

export const JOURNEY_TYPE_LABELS: Record<PriceJourney['type'], string> = {
  outbound: 'Aller',
  return: 'Retour',
  segment: 'Vol',
}
